import MadeWithCare from '../components/Commitment/MadeWithCare';
import Sustain from '../components/Commitment/Sustain';
import SafetyVideo from '../components/Commitment/SafetyVideo';

function Commitment() {
  return (
    <div className="commitment__container">
      <MadeWithCare/>
      <Sustain/>
      <SafetyVideo/> 
    </div>
  );
}

export default Commitment;